export default __webpack_public_path__ + "static/media/coffe7.ae546d7e.png";